export const getCreateUpdateWebhookPayload = (selectedWebhook) => {
    if(selectedWebhook){
        return {
            webhook_external_id: selectedWebhook?.webhook_external_id, 
            webhook_external_company_name: selectedWebhook?.webhook_external_company_name, 
            webhook_external_send_response_code: selectedWebhook?.webhook_external_send_response_code, 
            webhook_external_description: selectedWebhook?.webhook_external_description, 
            webhook_external_send_response_value: selectedWebhook?.webhook_external_send_response_value, 
            sample_webhook_response_json: selectedWebhook?.sample_webhook_response_json,
        }
    } else {
        return {
            webhook_external_id: "", 
            webhook_external_company_name: "", 
            webhook_external_send_response_code: null, 
            webhook_external_description: "", 
            webhook_external_send_response_value: "", 
            sample_webhook_response_json: "",
        }
    }
}